import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7300a24c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "upload-mod" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = {
  key: 0,
  class: "custom-box"
}
const _hoisted_4 = { class: "description" }

import { ref, watch, inject, computed } from "vue"
import VideoPlayer from "@/components/video/video.vue"
import {putUpload} from '@/hooks/index'
import { ImagePreview, Toast } from "vant";
import { Compressor } from '@/plugins/compressorImg'
import { v4 as uuidv4 } from 'uuid';

export default /*#__PURE__*/_defineComponent({
  __name: 'upload',
  props: {
    /**{content:'url', attach_type: 1, isGive: false}
     * content 显示的图片路径
     * attach_type: 媒体类型 1图片 2视频
     * isGive 是否为示例的图片
     */
    fileList: {
        type: Array,
    },
    imgPathData: {
        type: Object,
        default: () => { }
    },
    /** 可上传的类型 */
    accept: {
        type: String,
        // default: "*"
        default:"image/*, video/mp4"  // 目前测试环境不能上传，无法测试手机端是否能够上传成，待环境好了之后记得测试
    },
    // 是否压缩图片
    compressImage: {
      type: Boolean,
      default: true
    },
     // 图片压缩质量，满分为1，0.5表示压缩一半质量
     compressQuality: {
      type: Number,
      default: 0.8
    },
    // 上传模块名称,当前有：review,talk,after-sale,review-video (如需添加需联系后端)
    serviceName: {
        type: String,
        default: 'after-sale'
    }
},
  emits: ['upload','delFile'],
  setup(__props, { emit }) {

const props = __props




const get_icon_content_fn = computed(() => {
    let is_image = props.accept.indexOf('image')
    let is_video = props.accept.indexOf('video')
    if(is_image > -1 && is_video > -1) {
        return 'Upload photos or videos'
    }
    if(is_image > -1)  return 'Upload photos'
    if(is_video > -1)  return 'Upload videos'
    
})
const $http: any = inject("$http");
let video = ref()
let showAction = ref(false)
let upload = ref()
let showImg = ref(false)
let isPlay = ref(false)
let videoPreData:any = ref({})
let fileData = ref([]) as any


const handleCompressImage = async(file:any) => {
    return Compressor(file,props.compressQuality)
    }
const getSignUrl = async (data: any) => {
    // 可上传的文件类型 '1'-image,'2'-video,'3'-text
    const typeObj = {
        image: '1',
        video: '2',
        text: '3',
    }
    const size = data.file.size / 1024 / 1024
    const fileSuffix = data.file.name.match(/\.[^.]+$/g)[0]
    let formData = new FormData();
    formData.append('service_name', props.serviceName);
    formData.append('file_type', typeObj[filterType(data.file.type)]);
    formData.append('file_size', `${size}`);
    formData.append('filename', `${uuidv4().replace(/\-/g,'')}${fileSuffix}`);
    Toast.loading({
            duration: 0, // 持续展示 toast
            forbidClick: true,
            message: 'loading...'
        })
    const res = await $http.updateFileInspect(formData)
    if (res.code === 200) {
        const filePath = res.data.filename
        let isVideo = data.file.type.indexOf('video') !== -1
        let str = filePath.substr(0, filePath.indexOf('.'))
        let fileDatas = {
            // 存储的是图片或视频播放的全路径
            content:isVideo ? `${props.imgPathData.media_url}/${str}${props.imgPathData.media_suffix}` : `${props.imgPathData.image_url}/${res.data.filename}`,
            attach_type: isVideo ? 2 : 1,
        }
        // 存储到服务器的数据
        putUpload({url: res.data.url, file: data.file}).then((rs) => {
            if(rs.status === 200) {
                emit('upload', fileDatas)
            }
        })
        fileData.value= fileData.value.concat([fileDatas])
        Toast.clear()
    } else {
        Toast.clear()
        Toast('Network error, please upload photo/video again.')
    }

}
const filterType = (type: string) => {
    const typeArr = ['video', 'image']
   return typeArr.filter(item => type.includes(item))[0]
}
/**文件选择完毕后会触发 */
const afterRead = async(file: any) => {
    // 支持一次传多张和一次一张
    if (Array.isArray(file)) {
        file.forEach(async(item) => {
            if(item.file.type !== 'video/mp4'&&props.compressImage){
                const imgItem:any = await handleCompressImage(item.file)
                item.file = imgItem
            }
            getSignUrl(item)  
        })
    } else {
        if(file.file.type !== 'video/mp4'&&props.compressImage){
           const imgItem = await handleCompressImage(file.file)
           file.file = imgItem
        }
        getSignUrl(file)  
    }
}
const beforeRead = (file: any) => {
    fileData.value = fileData.value.filter((item:any) => !item.isGive)
    let fileDatas:any = []
    Array.isArray(file) ? fileDatas = file: fileDatas.push(file)
    // 上传前 可验证格式
    let len = fileDatas.length 
    let num = fileData.value.length + len
    if (len <= 5 && num <= 5) {
        // 视频校验时间,视频时长最多一分钟,图片最大10M
        return  new Promise (function(resolve:any, reject:any) {
                fileDatas.forEach((item:any) => {
                    if(item.type.includes('video')){
                        let url = URL.createObjectURL(item);         
                        let audioElement:any = new Audio(url);
                        audioElement.addEventListener("loadedmetadata",
                        function() {     
                            let duration =parseInt(audioElement.duration); //时长为秒，取整   最大一分钟
                            duration > 60 ? reject(): resolve(duration > 60)
                            if(duration > 60) return Toast('Video cannot exceed maximum 1 minute.') 
                        })
                    }else{
                        if( item.size > 10*1024*1024 ) {
                            Toast('Image cannot exceed maximum size of 10M.') // 图片最大10M
                        } 
                        item.size > 10*1024*1024 ? reject(): resolve(item.size > 10*1024*1024)
                    }
                })
            
        })
        // 下面是当上面视频不能按照时间进行校验时,按照文件大小进行校验
        // if(file.type.includes('video')&& file.size > 3000*1024){
        //     Toast('A maximum of 30 MB videos can be uploaded')
        //     return    !(file.size > 3000*1024)
        // }else if(file.size > 2){
        //     Toast('Images can only be uploaded to a maximum of 10 M') // 图片最大10M
        //     return    !(file.size > 1000*1024)
        // }
    } else {
        // 最多上传5个文件 文案需要修改
        Toast('Support uploading up to 5 files')
        return false
    }
}

const handlePreview = (file: any) => {
    if (file.attach_type == 1) {
        // 预览图片
        let imgData: any = []
        let startIndex = 0
        fileData.value.forEach((item: any, index: number) => {
            if (item.attach_type === 1) {
                imgData.push(item.content)
            }
        });
        startIndex = imgData.findIndex((item: any) => item.includes(file.content));
        showImg.value = true
        ImagePreview({
            images: [].concat(...imgData),
            startPosition: startIndex,
        });
    } else {
        // 预览视频
        showAction.value = true
        videoPreData.value = {
            // 视频路径
            videoUrl:file.content, 
            // 视频封面
            videoPost:file.content.replace(props.imgPathData.media_suffix,props.imgPathData.media_image_suffix)
        }
    }
}
const handleClose = () => {
    upload.value.closeImagePreview()
}
const popClose = () => {
    showAction.value = false
    isPlay.value = false
    video.value.onPlayerPause()
    handleClose()
}
const deleltFile = (val: any) => {
    fileData.value= fileData.value.filter((item:any)=>item.content != val.content)
    if(!fileData.value.length) {
        fileData.value = props.fileList
    }
    emit('delFile', fileData.value)
}
watch(() => props.fileList, (newVal) => {
    if (newVal) {
        fileData.value = JSON.parse(JSON.stringify(newVal))
    }
}, { immediate: true })

return (_ctx: any,_cache: any) => {
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_uploader = _resolveComponent("van-uploader")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(fileData), (item) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "video-play",
          onClick: ($event: any) => (handlePreview(item))
        }, [
          _createVNode(_component_van_image, {
            onClick: _withModifiers(($event: any) => (deleltFile(item)), ["stop"]),
            class: "close-tbn",
            width: "0.58rem",
            height: "0.58rem",
            fit: "cover",
            src: 'https://image.kilimall.com/kenya/wap/afterSales/ic_back_normal_2x.png'.webpFilters()
          }, null, 8, ["onClick", "src"]),
          _createVNode(_component_van_image, {
            width: "2.933rem",
            height: "2.933rem",
            fit: "cover",
            src: item.attach_type == 1 ? item.content.webpFilters():item.content.replace(__props.imgPathData.media_suffix,__props.imgPathData.media_image_suffix).webpFilters()
          }, null, 8, ["src"]),
          (item.type === 'video')
            ? (_openBlock(), _createBlock(_component_van_image, {
                key: 0,
                class: "icon-play",
                width: "0.91rem",
                height: "0.91rem",
                fit: "cover",
                src: 'https://image.kilimall.com/kenya/wap/afterSales/ic_play_2x.png'.webpFilters()
              }, null, 8, ["src"]))
            : _createCommentVNode("", true)
        ], 8, _hoisted_2))
      }), 256)),
      _createVNode(_component_van_uploader, {
        ref_key: "upload",
        ref: upload,
        "after-read": afterRead,
        "before-read": beforeRead,
        "before-delete": deleltFile,
        accept: __props.accept,
        onClosePreview: handleClose,
        "preview-size": "2.907rem",
        "max-count": 5,
        multiple: ""
      }, {
        default: _withCtx(() => [
          (_unref(fileData).length < 5)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_van_image, {
                  width: "45",
                  height: "45",
                  src: 'https://image.kilimall.com/kenya/wap/afterSales/ic_photo_2x.png'.webpFilters()
                }, null, 8, ["src"]),
                _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(get_icon_content_fn)), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["accept"])
    ]),
    _createVNode(_component_van_popup, {
      show: _unref(showAction),
      "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => (_isRef(showAction) ? (showAction).value = $event : showAction = $event)),
      onClosed: popClose,
      style: { width: '375px' }
    }, {
      default: _withCtx(() => [
        _createVNode(VideoPlayer, {
          ref_key: "video",
          ref: video,
          class: "video-main-box",
          videoSrc: _unref(videoPreData).videoUrl,
          videoPoster: _unref(videoPreData).videoPost,
          videoAspectRatio: '1:1',
          controlBar: {
                timeDivider: false,
                durationDisplay: false,
                remainingTimeDisplay: false,
                fullscreenToggle: false,
            },
          noClickFull: ""
        }, null, 8, ["videoSrc", "videoPoster"])
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}
}

})